import * as React from 'react';
import { SVGProps } from 'react';

const IconFileAnimationSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 10.5c.455 0 .882-.122 1.25-.335.368.213.795.335 1.25.335.455 0 .882-.122 1.25-.335a2.5 2.5 0 1 0 0-4.331A2.488 2.488 0 0 0 8 5.5c-.455 0-.882.122-1.25.334A2.5 2.5 0 1 0 5.5 10.5Zm2.05-1.069A1.504 1.504 0 0 1 6.5 8a1.504 1.504 0 0 1 1.95-1.431C8.166 6.974 8 7.468 8 8s.166 1.026.45 1.431a1.5 1.5 0 0 1-.9 0ZM5.5 6.5a1.5 1.5 0 0 1 .45.069c-.284.405-.45.899-.45 1.431s.166 1.026.45 1.431A1.5 1.5 0 0 1 4 8a1.5 1.5 0 0 1 1.5-1.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.97 2v12H15V2H.97Zm1 11V3H14v10H1.97Z"
    />
  </svg>
);
export default IconFileAnimationSizeS;
